/* eslint-disable */

export enum CustomerPageGroupType {
	Unknown = 0,
	Normal = 1,
	FreightAndFees = 2,
	
}
